function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["className"],
  _excluded2 = ["className", "variant"],
  _excluded3 = ["className"],
  _excluded4 = ["className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { useRTL } from "../../../hooks/useRTL";
import * as ToastPrimitives from "../../../lib/toast/toast-react";
import { cn } from "../../../lib/utils";
import { cva } from 'class-variance-authority';
import React from 'react';
import { styles } from "../../style/toast";
import { jsx as _jsx } from "react/jsx-runtime";
var ToastProvider = ToastPrimitives.Provider;
var ToastViewport = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var isRTL = useRTL();
  return /*#__PURE__*/_jsx(ToastPrimitives.Viewport, _objectSpread({
    ref: ref,
    className: cn('moly-toast-viewport', styles, 'fixed top-0 z-[9999] flex max-h-screen flex-col justify-center items-center w-0 [&:not(:empty)]:w-max pointer-events-none', {
      'translate-x-1/2 right-1/2': isRTL,
      '-translate-x-1/2 left-1/2': !isRTL
    }, className)
  }, props));
});
ToastViewport.displayName = ToastPrimitives.Viewport.displayName;
var toastVariants = cva('group pointer-events-auto relative flex items-center justify-between space-x-4 overflow-hidden rounded-md border shadow-lg transition-all data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:slide-out-to-top-full data-[state=open]:slide-in-from-top-full', {
  variants: {
    variant: {
      default: 'border bg-background flex justify-center align-center border-0 rounded-lg mb-2',
      destructive: 'destructive group border-destructive bg-destructive text-destructive-foreground'
    }
  },
  defaultVariants: {
    variant: 'default'
  }
});
var Toast = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var className = _ref2.className,
    variant = _ref2.variant,
    props = _objectWithoutProperties(_ref2, _excluded2);
  var isRTL = useRTL();
  return /*#__PURE__*/_jsx(ToastPrimitives.Root, _objectSpread({
    ref: ref,
    className: cn('moly-toast-background', toastVariants({
      variant: variant
    }), "".concat(isRTL ? 'moly-toast-background-rtl' : ''), className)
  }, props));
});
Toast.displayName = ToastPrimitives.Root.displayName;
var ToastAction = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var className = _ref3.className,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsx(ToastPrimitives.Action, _objectSpread({
    ref: ref,
    className: cn('inline-flex h-8 shrink-0 items-center justify-center rounded-md border bg-transparent px-3 text-sm font-medium ring-offset-background transition-colors hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 group-[.destructive]:border-muted/40 group-[.destructive]:hover:border-destructive/30 group-[.destructive]:hover:bg-destructive group-[.destructive]:hover:text-destructive-foreground group-[.destructive]:focus:ring-destructive', className)
  }, props));
});
ToastAction.displayName = ToastPrimitives.Action.displayName;
var ToastTitle = /*#__PURE__*/React.forwardRef(function (_ref4, ref) {
  var className = _ref4.className,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsx(ToastPrimitives.Title, _objectSpread({
    ref: ref,
    className: cn('text-sm font-medium moly-toast-title', className)
  }, props));
});
ToastTitle.displayName = ToastPrimitives.Title.displayName;
export { Toast, ToastAction, ToastProvider, ToastTitle, ToastViewport };